module.exports = __webpack_public_path__ + "static/media/incoming-shipments.c8544ba9.png";